var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"icon":"mdi-plus","title":"Add"},on:{"click":function($event){return _vm.create()}}}),_c('Table',{staticClass:"my-5",on:{"edit":_vm.edit}}),_c('Form',{ref:"form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }